import React, { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import { IWorkflowItem } from '../interfaces'
import { useTranslation } from 'react-i18next'

const WorkflowItem = ({
    workflow,
    hasWriteAccess,
}: {
    workflow: IWorkflowItem
    hasWriteAccess: boolean
}): ReactElement => {
    const { t } = useTranslation()
    const onDragStart = (
        event: React.DragEvent<HTMLDivElement>,
        nodeType: string,
    ) => {
        if (!hasWriteAccess) {
            event.preventDefault()
            return
        }
        event.dataTransfer.setData('application/reactflow', nodeType)
        event.dataTransfer.effectAllowed = 'move'
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            p={1}
            mt={1}
            mb={1}
            style={{
                cursor: hasWriteAccess ? 'grab' : 'default',
                boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            }}
            onDragStart={(event) =>
                onDragStart(event, JSON.stringify(workflow))
            }
            draggable={hasWriteAccess}
            id={workflow.name}
        >
            <Box display="flex" alignItems="center">
                <Box
                    sx={{ filter: 'brightness(0)' }}
                    ml={1}
                    height="27px"
                    width="27px"
                    id={workflow.name + '-logo'}
                >
                    {' '}
                    {workflow.logo ? (
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                            src={workflow.logo}
                            loading="lazy"
                            alt={t('workflowLogo', { name: workflow.name })}
                        />
                    ) : (
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                            src="/assets/images/icons/Truck-Icon.svg"
                            loading="lazy"
                            alt={t('truckIconDefaultWorkflow')}
                        />
                    )}
                </Box>
                <Typography variant="body1" ml={1} marginTop="2px">
                    {workflow.name}
                </Typography>
            </Box>
        </Box>
    )
}

export default WorkflowItem
